import React, { useEffect, useState } from 'react';
import { Box, Select, MenuItem, Typography } from '@mui/material';
import TextInput from '../../inputs/textInput';

interface FormCompanyProps {
  data?: {
    output?: {
      order_company?: string[];
      order_reference?: string;
    };
  };
}

const FormCompany = ({ data }: FormCompanyProps) => {
  const [formData, setFormData] = useState({
    company: '',
    order_reference: '',
  });

  useEffect(() => {
    setFormData({
      company: data?.output?.order_company?.[0] || '',
      order_reference: data?.output?.order_reference || '',
    });
  }, [data]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name as string]: value as string }));
  };

  const inputSx = {
    borderLeft: (theme: any) => `4px solid ${theme.palette.text.green}`,
    borderBottom: (theme: any) => `2px solid ${theme.palette.text.green}`,
    borderTop: 0,
    borderRight: 0,
    borderRadius: 1,
    px: 0.25,
    py: 0.125,
    width: '150px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderLeft: '4px solid border.green',
      borderBottom: '2px solid border.green',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderLeft: '4px solid border.green',
      borderBottom: '2px solid border.green',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderLeft: '4px solid border.green',
      borderBottom: '2px solid border.green',
    },
  };

  const redInputSx = {
    ...inputSx,
    borderLeft: (theme: any) => `4px solid ${theme.palette.text.red}`,
    borderBottom: (theme: any) => `2px solid ${theme.palette.text.red}`,
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderLeft: '4px solid border.red',
      borderBottom: '2px solid border.red',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderLeft: '4px solid border.red',
      borderBottom: '2px solid border.red',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderLeft: '4px solid border.red',
      borderBottom: '2px solid border.red',
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
        p: 1,
        bgcolor: 'background.lightGrey',
        width: '100%',
        color: 'text.blue',
        boxSizing: 'border-box',
        borderRadius: 1,
      }}
    >
      <Box component="form" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={{ m: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 1 }}>
            <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>ĮMONĖ</Typography>
            <TextInput
              id="company"
              name="company"
              size="small"
              sx={inputSx}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 1 }}>
            <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>GRUPĖ</Typography>
            <TextInput
              id="group"
              name="group"
              size="small"
              sx={inputSx}
            />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 1 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>KROVINYS</Typography>
              <TextInput
                id="cargo"
                name="cargo"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 1 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>PAKROVIMAS</Typography>
              <Select
                id="loading"
                name="loading"
                size="small"
                defaultValue="FTL"
                sx={inputSx}
              >
                <MenuItem value="FTL">FTL</MenuItem>
                <MenuItem value="LTL">LTL</MenuItem>
              </Select>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
            <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>INCOTERM</Typography>
            <TextInput
              id="incoterm"
              name="incoterm"
              size="small"
              sx={inputSx}
            />
          </Box>
        </Box>

        <Box sx={{ m: 2.5 }}>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>ATSAKINGAS</Typography>
              <TextInput
                id="responsible"
                name="responsible"
                size="small"
                sx={inputSx}
              />
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <TextInput
              id="group2"
              name="group2"
              size="small"
              sx={{ ...inputSx, mb: 0.5 }}
            />
          </Box>
          <Box>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 0.5 }}>
                <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>PRIST. KRYPTIS</Typography>
                <TextInput
                  id="direction"
                  name="direction"
                  size="small"
                  sx={inputSx}
                />
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 0.5 }}>
                <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>T.P. TIPAS</Typography>
                <TextInput
                  id="type"
                  name="type"
                  size="small"
                  sx={inputSx}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ m: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 1 }}>
            <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>KLIENTAS</Typography>
            <TextInput
              id="client"
              name="client"
              size="small"
              sx={{ ...redInputSx, width: '25%' }}
            />
            <TextInput
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              size="small"
              sx={inputSx}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 1 }}>
            <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>KATEGORIJA</Typography>
            <TextInput
              id="category"
              name="category"
              size="small"
              sx={{ ...inputSx, width: '25%' }}
            />
            <TextInput
              id="category2"
              name="category2"
              size="small"
              sx={inputSx}
            />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>LIMITO LIKUTIS</Typography>
              <TextInput
                id="limit"
                name="limit"
                type="number"
                size="small"
                sx={{ ...inputSx, width: '15%' }}
              />
              <Typography sx={{ color: 'text.red', fontWeight: 700, fontSize: (theme: any) => theme.typography.fontSizes.body, ml: 1 }}>
                0.00 DĖMESIO!
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>ADRESAS</Typography>
              <TextInput
                id="address"
                name="address"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>KONTAKTAS</Typography>
              <TextInput
                id="contact"
                name="contact"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>E-PAŠTAS</Typography>
              <TextInput
                id="email"
                name="email"
                type="email"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>TEL.</Typography>
              <TextInput
                id="phone"
                name="phone"
                type="tel"
                size="small"
                sx={inputSx}
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{ m: 2.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
            <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>SUTARTIES UŽSAKYMO NR.</Typography>
            <TextInput
              id="order_reference"
              name="order_reference"
              value={formData.order_reference}
              onChange={handleChange}
              size="small"
              sx={inputSx}
            />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>ROUNDTRIP NR.</Typography>
              <TextInput
                id="roundtrip"
                name="roundtrip"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>KROVINIO NR.</Typography>
              <TextInput
                id="cargoNr"
                name="cargoNr"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>APSKRITIS</Typography>
              <TextInput
                id="district"
                name="district"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>MIESTAS</Typography>
              <TextInput
                id="city"
                name="city"
                size="small"
                sx={inputSx}
              />
            </Box>
          </Box>
        </Box>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 2 }}>
            <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>UŽSAKYMO DATA</Typography>
            <TextInput
              id="date"
              name="date"
              type="date"
              value={new Date().toISOString().split('T')[0]}
              InputProps={{ readOnly: true }}
              size="small"
              sx={inputSx}
            />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>ATSK. SĄSK.</Typography>
              <TextInput
                id="invoice"
                name="invoice"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>SĄSKAITA.</Typography>
              <TextInput
                id="invoice2"
                name="invoice2"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>VALIUTA</Typography>
              <TextInput
                id="currency"
                name="currency"
                value="EUR"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>SUTARTIS</Typography>
              <TextInput
                id="contract"
                name="contract"
                size="small"
                sx={inputSx}
              />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mb: 0.5 }}>
              <Typography sx={{ fontSize: (theme: any) => theme.typography.fontSizes.body, width: '100px' }}>KLIENTO PVM KODAS</Typography>
              <TextInput
                id="PVM"
                name="PVM"
                size="small"
                sx={inputSx}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FormCompany;
